import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeIn20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFadeIn20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M10.854 1.117q.095.001.184.026c4.454.494 7.918 4.27 7.918 8.855l-.012.458a8.91 8.91 0 0 1-7.883 8.393.7.7 0 0 1-.207.033.75.75 0 0 1-.75-.75V1.867a.75.75 0 0 1 .75-.75m-3.025.438a.75.75 0 0 1 .751.75V17.69a.75.75 0 0 1-1.5 0V2.305a.75.75 0 0 1 .75-.75m3.775 15.685a7.41 7.41 0 0 0 0-14.487zM4.814 3.157a.75.75 0 0 1 .75.75v12.186a.75.75 0 0 1-1.5 0V3.907a.75.75 0 0 1 .75-.75m-3.02 2.72a.75.75 0 0 1 .75.75v6.742a.75.75 0 1 1-1.5 0V6.627a.75.75 0 0 1 .75-.75"
            />
        </svg>
    );
}
export default memo(IconFadeIn20);
